<template>
  <div
    :id="`${internalId}_wrap`"
    :class="{
      'newline': newline,
      'fillin-wrap': true,
      'validation-error': internalError
    }">
    <input
      v-if="formInputName"
      type="hidden"
      :name="formInputName"
      :value="internalValue" />

    <label
      v-if="label"
      :id="`${internalId}_label`"
      :class="{
        'fillin-label': true,
        'required': required
      }"
      :for="`${internalId}_input`">
      {{ label }}
      <span
        v-if="required"
        class="required"
        >&nbsp;*</span
      >
    </label>
    <input
      :id="`${internalId}_input`"
      :type="internalType"
      :autocomplete="autocompleteAttribute ? autocompleteAttribute : ''"
      v-model="internalValue"
      :max-length="maxLength"
      :class="{
        fillin: true,
        valid: !internalError,
        error: internalError
      }"
      :disabled="internalDisabled"
      :aria-required="required"
      :aria-invalid="internalError"
      :aria-describedby="internalError ? `${internalId}_input_error` : null" />
    <div
      v-if="internalError"
      :id="`${internalId}_input_error`">
      <span
        v-for="msg in errorMessages"
        :key="msg"
        class="validation-message error">
        <span class="validation-message__text">{{ msg }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { nextId } from '@/core/util'

export default {
  name: 'FillinComponent',
  emits: ['update:modelValue'],
  props: {
    id: String,
    name: String,
    type: String,
    modelValue: String,
    label: String,
    error: Boolean,
    disabled: Boolean,
    required: Boolean,
    newline: Boolean,
    errorMessages: Array,
    autocompleteAttribute: String,
    maxLength: {
      type: Number,
      default: 100
    },
    // This is used if this component is used in a form outside of the legacy code
    formInputName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalId: '',
      internalValue: '',
      internalType: '',
      internalError: false,
      internalDisabled: false
    }
  },
  created() {
    this.internalId = this.id || 'fillin_' + nextId()
    this.internalValue = this.modelValue
    this.internalType = this.type || 'text'
    this.internalError = this.error
    this.internalDisabled = this.disabled
    if (this.errorMessages && this.errorMessages.length > 0) {
      this.internalError = true
    }
  },
  watch: {
    modelValue() {
      if (this.internalValue !== this.modelValue) {
        this.internalValue = this.modelValue
      }
    },
    type() {
      if (this.internalType !== this.type) {
        this.internalType = this.type
      }
    },
    error() {
      if (this.internalError !== this.error) {
        this.internalError = this.error
      }
    },
    errorMessages() {
      if (this.errorMessages && this.errorMessages.length > 0) {
        this.internalError = true
      } else {
        this.internalError = false
      }
    },
    disabled() {
      if (this.internalDisabled !== this.disabled) {
        this.internalDisabled = this.disabled
      }
    },
    internalValue() {
      this.$emit('update:modelValue', this.internalValue)
    }
  }
}
</script>

<style lang="less" scoped>
.fillin-wrap {
  display: flex;
  flex-direction: column;
}
</style>
